export const sagbyoStaticData = [
    {
      cardNumber: 1,
      cardHeadingNumber: 6,
      title: 'Your Novated Lease Checklist',
      prefix:
        '<p>This checklist has been prepared to assist you in understanding your obligations and key features under the proposed lease. This checklist is a requirement by your employer and you will need to complete this checklist.</p><p>If you have any questions, or need assistance to complete the checklist please contact your Maxxia representative.</p>',
      prefixPdf:
        'This checklist contains information and facts in relation to your Novated Lease proposal. It has been prepared to assist you in understanding your obligations under the proposed lease.',
      pdfText:
        'You have already accepted this checklist at the proposal stage.',
      datablocks: [
        {
            heading: 'Important Points to Look For on Your Quote',
            showIds: true,
            checklistItems: [
                {
                  id: 1,
                  isChecked: false,
                  text: 'Ensure you have received a completed quote template from the BYO provider in the form of the BYO Financier or BYO Leasing Provider Quote Template (as applicable).',
                },
                {
                  id: 2,
                  isChecked: false,
                  text: 'Acknowledge all communications in relation to the completion of the required documentation must be between the employee and the BYO Provider.',
                },
                {
                  id: 3,
                  isChecked: false,
                  text: 'Acknowledge that you will need to submit all completed documentation to Smart via email to customersupport@smart.com.au (this is the responsibility of the employee, not the BYO provider).',
                },
                {
                  id: 4,
                  isChecked: false,
                  text: 'Acknowledge you understand the South Australian Government strongly recommends that independent financial advice is obtained prior to entering into a BYO lease.',
                },
                {
                  id: 5,
                  isChecked: false,
                  text: 'Acknowledge all information provided in the BYO leasing application is accurate, and that neither SA Government nor Smart are responsible for any errors or omissions in that information or the making of any payments where there are insufficient funds in the employee’s novated leasing balance.',
                },
                {
                  id: 6,
                  isChecked: false,
                  text: 'Acknowledge that you are responsible for any FBT liabilities, if you have any queries on this once your lease begins you will need to contact your Salary Packaging provider.'
                },
                {
                  id: 7,
                  isChecked: false,
                  text: "Acknowledge all administration costs as charged by the BYO Provider (noting additional Administration Fees will apply from Smart to establish and administer the lease on an ongoing basis)."
                }
            ]
        }
      ]
    },
    {
      cardNumber: 1,
      cardHeadingNumber: 7,
      title: 'Your Authorisation',
      pdfText:
        'You have already accepted this checklist at the proposal stage.',
      datablocks: [
        {
          
          showIds: true,
          checklistItems: [
            {
                id: 1,
                isChecked: false,
                text: "This is the lease I have discussed with my consultant, and I'm happy to proceed."
            },
            {
                id: 2,
                isChecked: false,
                text: "I acknowledge that the prices and rates specified above may be subject to change by the manufacturer or relevant authorities before delivery."
            },
            {
                id: 3,
                isChecked: false,
                text: "I acknowledge that Maxxia may receive commissions or rebates and retain interest earned on moneys held in connection with some services it provides or arranges to be provided by third Parties."
            }
          ]
        }
      ]
    }
]